<template>
  <div class="container-fluid mt-4">
    <div style="max-width: 900px; margin: 0 auto;">
      <h2 style="font-size: 20px; font-weight: 600; color: #32325d; margin-bottom: 16px;">
        Intervenciones
      </h2>

      <card-intervenciones :intervenciones="intervenciones" :cargando="cargando" />
    </div>
  </div>
</template>

<script>
import AuditoriasGateway from '@/gateways/AuditoriasGateway'
import CardIntervenciones from './components/CardIntervenciones'

export default {
  name: 'IntervencionesHome',
  components: { CardIntervenciones },
  data () {
    return {
      intervenciones: { activas: [], historial: [] },
      cargando: true
    }
  },
  created () {
    this.cargarIntervenciones()
  },
  methods: {
    cargarIntervenciones () {
      var self = this
      AuditoriasGateway.intervenciones()
        .then(function (res) {
          if (!res.data.success) return
          self.intervenciones = res.data.data || { activas: [], historial: [] }
        })
        .catch(function () {
          // Si falla, la tarjeta muestra su propio estado vacío.
        })
        .finally(function () {
          self.cargando = false
        })
    }
  }
}
</script>
